export default "__VITE_ASSET__BNwgTHsG__"